class Accordion {
    constructor(){
        if(document.querySelector('.wrm-accordion')){
            this.accordion = document.querySelectorAll('.accordion-item')
            this.events()
        }
    }
    events(){
        this.accordion.forEach(item => {
            let accordianItem = item.querySelector('.header')
            let childAccordion = item.querySelector('.accordion-item')
            if(childAccordion){
                childAccordion.classList.add('child-accordion')
            }
            accordianItem.addEventListener('click', e => {
                item.classList.toggle('active')
                let dropdownHeight = item.querySelector('.dropdown').offsetHeight
                let content = item.querySelector('.content')
                if(item.classList.contains('active')){
                    content.style.height =  dropdownHeight + 'px'
                    if(item.classList.contains('child-accordion')){
                        let parentHeight = item.parentElement.parentElement.parentElement.offsetHeight
                        item.parentElement.parentElement.parentElement.style.height = parentHeight + dropdownHeight + 'px'
                    }
                } else {
                    content.style.height = '0px'
                    if(item.classList.contains('child-accordion')){
                        let parentHeight = item.parentElement.parentElement.parentElement.offsetHeight
                        item.parentElement.parentElement.parentElement.style.height = parentHeight - dropdownHeight + 'px'
                    }
                }
            })
            
        })
    }
}

export default Accordion